/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';

import { rhythm } from '../utils/typography';

const Section = styled.section`
  display: flex;
  align-items: center;
  margin-bottom: ${rhythm(2.5)};
`;

type ImageProps = {
  size: number;
};

const Image = styled.img`
  margin-right: ${rhythm(1 / 2)};
  margin-bottom: 0;
  max-width: ${({ size }: ImageProps) => size}px;
`;

const Summary = styled.p`
  margin: 0;
`;

type Props = {
  hideSummary?: boolean;
  date?: string;
  readDuration?: string;
  gravatarSize?: number;
};

const Bio: React.FC<Props> = ({
  hideSummary,
  date,
  readDuration,
  gravatarSize = 50,
}) => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      site {
        siteMetadata {
          author {
            name
            summary
            gravatar
          }
        }
      }
    }
  `);

  const { author } = data.site.siteMetadata;
  return (
    <Section>
      <Image
        src={`https://www.gravatar.com/avatar/${author.gravatar}?s=250&d=mm&r=x`}
        role="presentation"
        alt=""
        size={gravatarSize}
      />
      <Summary>
        {!hideSummary && `Written by `}
        <strong>{author.name}</strong>
        {!hideSummary && ` ${author.summary}`}
        {date && `, ${date}`}
        {readDuration && `, ${readDuration} read`}
      </Summary>
    </Section>
  );
};

export default Bio;
